import React, { useState } from "react";
import TabLog from "./tab-log";
import ChatBox from "./chat-box";

const SecurityMonitoring: React.FC = () => {

  const [tabLogName, setTabLogName] = useState<string[]>([]);

  const handleMessageFromTabLog = (data: string[]) => {
    setTabLogName(data);
  };

  return (
    <>
      <TabLog tabLogName={handleMessageFromTabLog} />
      <ChatBox dataLogName={tabLogName} />
    </>
  );
};

export default SecurityMonitoring;
